/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitRankingItem
 */
export interface MonitRankingItem {
    /**
     * 
     * @type {number}
     * @memberof MonitRankingItem
     */
    year: number;
    /**
     * 
     * @type {string}
     * @memberof MonitRankingItem
     */
    rank: string;
    /**
     * 
     * @type {number}
     * @memberof MonitRankingItem
     */
    month: number;
}

/**
 * Check if a given object implements the MonitRankingItem interface.
 */
export function instanceOfMonitRankingItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "year" in value;
    isInstance = isInstance && "rank" in value;
    isInstance = isInstance && "month" in value;

    return isInstance;
}

export function MonitRankingItemFromJSON(json: any): MonitRankingItem {
    return MonitRankingItemFromJSONTyped(json, false);
}

export function MonitRankingItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitRankingItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'year': json['year'],
        'rank': json['rank'],
        'month': json['month'],
    };
}

export function MonitRankingItemToJSON(value?: MonitRankingItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'year': value.year,
        'rank': value.rank,
        'month': value.month,
    };
}

